module.exports = __webpack_public_path__ + "bfc6c2209ab449f9578809c44aabc804.svg";